import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  LEAVE_GENERTION_GET_REQUEST,
  LEAVE_GENERTION_GET_SUCCESS,
  LEAVE_GENERTION_GET_FAILURE,
  LEAVE_GENERTION_GET_RESET,
  LEAVE_GENERTION_EDIT_REQUEST,
  LEAVE_GENERTION_EDIT_SUCCESS,
  LEAVE_GENERTION_EDIT_FAILURE,
  LEAVE_GENERTION_EDIT_RESET,
  LEAVE_GENERTION_IMPORT_REQUEST,
  LEAVE_GENERTION_IMPORT_SUCCESS,
  LEAVE_GENERTION_IMPORT_FAILURE,
  LEAVE_GENERTION_IMPORT_RESET,
  LEAVE_GENERTION_EXPORT_REQUEST,
  LEAVE_GENERTION_EXPORT_SUCCESS,
  LEAVE_GENERTION_EXPORT_FAILURE,
  LEAVE_GENERTION_EXPORT_RESET,
  LEAVE_GENERTION_USER_EXPORT_REQUEST,
  LEAVE_GENERTION_USER_EXPORT_SUCCESS,
  LEAVE_GENERTION_USER_EXPORT_FAILURE,
  LEAVE_GENERTION_USER_EXPORT_RESET,
} from './../../constants'

export function getLeaveGeneration(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/leave-generations/${id}`,
      method: 'GET',
      types: [
        LEAVE_GENERTION_GET_REQUEST,
        LEAVE_GENERTION_GET_SUCCESS,
        LEAVE_GENERTION_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function editLeaveGeneration(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/leave-generations/${id}`,
      method: 'PUT',
      types: [
        LEAVE_GENERTION_EDIT_REQUEST,
        LEAVE_GENERTION_EDIT_SUCCESS,
        LEAVE_GENERTION_EDIT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function importLeaveGeneration(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/leave-generations/imports`,
      method: 'POST',
      types: [
        LEAVE_GENERTION_IMPORT_REQUEST,
        LEAVE_GENERTION_IMPORT_SUCCESS,
        LEAVE_GENERTION_IMPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: payload,
    },
  }
}

export function exportLeaveGeneration(year = 2018, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/leave-generations/exports?year=${year}`,
      method: 'GET',
      types: [
        LEAVE_GENERTION_EXPORT_REQUEST,
        LEAVE_GENERTION_EXPORT_SUCCESS,
        LEAVE_GENERTION_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function exportLeaveGenerationUser(user_id, year, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/leave-generations/exports/${user_id}?year=${year}`,
      method: 'GET',
      types: [
        LEAVE_GENERTION_USER_EXPORT_REQUEST,
        LEAVE_GENERTION_USER_EXPORT_SUCCESS,
        LEAVE_GENERTION_USER_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function resetGetLeaveGeneration() {
  return {
    type: LEAVE_GENERTION_GET_RESET,
  }
}
export function resetEditLeaveGeneration() {
  return {
    type: LEAVE_GENERTION_EDIT_RESET,
  }
}
export function resetImportLeaveGeneration() {
  return {
    type: LEAVE_GENERTION_IMPORT_RESET,
  }
}
export function resetExportLeaveGeneration() {
  return {
    type: LEAVE_GENERTION_EXPORT_RESET,
  }
}
export function resetExportLeaveGenerationUser() {
  return {
    type: LEAVE_GENERTION_USER_EXPORT_RESET,
  }
}



// WEBPACK FOOTER //
// ./src/actions/leave-generation/leave-generation-action.js